import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/journey",
    name: "Home",
    component: Home,
  },
  {
    path: "/journey/roadmap",
    name: "Fill data",
    component: () => import("../views/roadmap.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/1",
    name: "i want",
    component: () => import("../components/journey/IWant.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/2",
    name: "i am",
    component: () => import("../components/journey/Iam.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/3",
    name: "i need",
    component: () => import("../components/journey/Ineed.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/4",
    name: "i can",
    component: () => import("../components/journey/ican.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/7",
    name: "perception",
    component: () => import("../components/journey/Perception.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/8",
    name: "Sociability",
    component: () => import("../components/journey/Sociability.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/9",
    name: "Aggression",
    component: () => import("../components/journey/Aggression.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/10",
    name: "Inconsistency",
    component: () => import("../components/journey/Inconsistency.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/journey/12",
    name: "Working Style",
    component: () => import("../components/journey/WorkingStyle.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/13",
    name: "Scheme",
    component: () => import("../components/journey/stressKerja.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/result/:type",
    name: "result",
    component: () => import("../components/result/mainResult.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/journey/thanks",
    name: "journey",
    component: () => import("../views/registerSuccess.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/privacyPolicy.vue"),
  },
  {
    path: "/penjurusan",
    name: "penjurusan",
    component: () => import("../views/penjurusan/penjurusan.vue"),
  },
  {
    path: "/penjurusan/katalog",
    name: "penjurusan-katalog",
    component: () => import("../views/penjurusan/katalog.vue"),
  },
  {
    path: "/seleksi-kerja/pdf",
    name: "seleksi-kerja",
    component: () =>
      import("../views/seleksiKerja/downloadPdfSeleksiKerja.vue"),
  },
  {
    path: "/penjurusan/detail/:id",
    name: "penjurusan-detail",
    component: () => import("../components/penjurusan/PenjurusanDetail.vue"),
  },
  {
    path: "/penjurusan/katalog/form",
    name: "penjurusan-katalog-form",
    component: () => import("../views/penjurusan/formKatalog.vue"),
  },
  {
    path: "/academic-psychogram",
    name: "academic-psychogram",
    component: () =>
      import("../views/academicPsychogram/AcademicPsychogram.vue"),
  },
  {
    path: "/verify/tb/:id",
    name: "verify-eSignature-tb",
    component: () => import("../views/verify/eSignatureTemanbakat"),
  },
  {
    path: "/verify/ha/:id",
    name: "verify-eSignature-ha",
    component: () => import("../views/verify/eSignatureAnargya"),
  },
  {
    path: "/minat-kepribadian",
    name: "minat kepribadian",
    component: () => import("../views/minatKepribadian/minatKepribadian"),
  },
  {
    path: "/tutorial-spam-email",
    name: "Tutorial Spam Email",
    component: () => import("../views/tutorialTemanBakat/tutorialSpamEmail"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
    return { x: 0, y: 0 };
  },
});

export default router;
